import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface Vehicle {
  imagePath: string;
}

const sliderVehicleList: Vehicle[] = [
  { imagePath: '/static/home_page/sterling_cadillac/img_slider_1.png' },
  { imagePath: '/static/home_page/sterling_cadillac/img_slider_2.png' },
  { imagePath: '/static/home_page/sterling_cadillac/img_slider_3.png' },
  { imagePath: '/static/home_page/sterling_cadillac/img_slider_4.png' },
  { imagePath: '/static/home_page/sterling_cadillac/img_slider_5.png' },
];

const AUTO_SCROLL_INTERVAL = 4000;
const TRANSITION_DURATION = 700;

const ImageSlider: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [
    isPaused,
    // setIsPaused
  ] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const sliderHeight = isMobile ? '220px' : isTablet ? '380px' : '560px';

  const goToIndex = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrentIndex(index);
      setTimeout(() => setIsTransitioning(false), TRANSITION_DURATION);
    },
    [isTransitioning],
  );

  const goNext = useCallback(() => {
    goToIndex((currentIndex + 1) % sliderVehicleList.length);
  }, [currentIndex, goToIndex]);

  // const goPrev = useCallback(() => {
  //   goToIndex(
  //     (currentIndex - 1 + sliderVehicleList.length) % sliderVehicleList.length,
  //   );
  // }, [currentIndex, goToIndex]);

  // Auto-scroll logic
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(goNext, AUTO_SCROLL_INTERVAL);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isPaused, goNext]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        // borderRadius: { xs: 2, sm: 3, md: 4 },
        // boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        // bgcolor: '#0a0a0a',
        userSelect: 'none',
      }}
      //   onMouseEnter={() => setIsPaused(true)}
      //   onMouseLeave={() => setIsPaused(false)}
    >
      {/* Slides Track */}
      <Box
        sx={{
          display: 'flex',
          width: `${sliderVehicleList.length * 100}%`,
          transform: `translateX(-${(currentIndex * 100) / sliderVehicleList.length}%)`,
          transition: isTransitioning
            ? `transform ${TRANSITION_DURATION}ms cubic-bezier(0.77, 0, 0.175, 1)`
            : 'none',
          height: sliderHeight,
        }}
      >
        {sliderVehicleList.map((vehicle, idx) => (
          <Box
            key={idx}
            sx={{
              width: `${100 / sliderVehicleList.length}%`,
              flexShrink: 0,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box
              component='img'
              src={vehicle.imagePath}
              alt={`Vehicle slide ${idx + 1}`}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: 'block',
                // transform: idx === currentIndex ? 'scale(1.04)' : 'scale(1)',
                // transition: `transform ${AUTO_SCROLL_INTERVAL}ms ease-out`,
              }}
            />
            {/* Subtle gradient overlay for depth */}
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                background:
                  'linear-gradient(to top, rgba(0,0,0,0.35) 0%, transparent 50%)',
                pointerEvents: 'none',
              }}
            />
          </Box>
        ))}
      </Box>

      {/* Prev Button */}
      {/* <IconButton
        onClick={goPrev}
        aria-label='Previous slide'
        sx={{
          position: 'absolute',
          left: { xs: 6, sm: 14 },
          top: '50%',
          transform: 'translateY(-50%)',
          bgcolor: 'rgba(255,255,255,0.12)',
          backdropFilter: 'blur(8px)',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.2)',
          width: { xs: 32, sm: 44 },
          height: { xs: 32, sm: 44 },
          transition: 'all 0.2s ease',
          '&:hover': {
            bgcolor: 'rgba(255,255,255,0.25)',
            transform: 'translateY(-50%) scale(1.08)',
          },
        }}
      >
        <ArrowBackIosNewIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />
      </IconButton> */}

      {/* Next Button */}
      {/* <IconButton
        onClick={goNext}
        aria-label='Next slide'
        sx={{
          position: 'absolute',
          right: { xs: 6, sm: 14 },
          top: '50%',
          transform: 'translateY(-50%)',
          bgcolor: 'rgba(255,255,255,0.12)',
          backdropFilter: 'blur(8px)',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.2)',
          width: { xs: 32, sm: 44 },
          height: { xs: 32, sm: 44 },
          transition: 'all 0.2s ease',
          '&:hover': {
            bgcolor: 'rgba(255,255,255,0.25)',
            transform: 'translateY(-50%) scale(1.08)',
          },
        }}
      >
        <ArrowForwardIosIcon sx={{ fontSize: { xs: 14, sm: 18 } }} />
      </IconButton> */}

      {/* Dot Indicators */}
      {/* <Box
        sx={{
          position: 'absolute',
          bottom: { xs: 10, sm: 16 },
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: { xs: '6px', sm: '8px' },
          zIndex: 2,
        }}
      >
        {sliderVehicleList.map((_, idx) => (
          <Box
            key={idx}
            onClick={() => goToIndex(idx)}
            sx={{
              width:
                idx === currentIndex ? { xs: 22, sm: 28 } : { xs: 7, sm: 8 },
              height: { xs: 7, sm: 8 },
              borderRadius: '99px',
              bgcolor: idx === currentIndex ? '#fff' : 'rgba(255,255,255,0.4)',
              cursor: 'pointer',
              transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow:
                idx === currentIndex ? '0 0 8px rgba(255,255,255,0.6)' : 'none',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.75)',
              },
            }}
          />
        ))}
      </Box> */}

      {/* Progress Bar */}
      {/* <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: '3px',
          bgcolor: 'rgba(255,255,255,0.85)',
          width: isPaused ? '0%' : '100%',
          animation: isPaused
            ? 'none'
            : `progress ${AUTO_SCROLL_INTERVAL}ms linear infinite`,
          '@keyframes progress': {
            '0%': {
              width: '0%',
              left: `${(currentIndex * 100) / sliderVehicleList.length}%`,
            },
            '100%': {
              width: `${100 / sliderVehicleList.length}%`,
              left: `${(currentIndex * 100) / sliderVehicleList.length}%`,
            },
          },
          pointerEvents: 'none',
        }}
      /> */}
    </Box>
  );
};

export default ImageSlider;
